import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WebsocketService } from '../../services/websocket';
import { IMessengerConnector } from '../../types/all.type';
import {SenderService} from '../../services/sender.service';
import {InterfaceService} from '../../services/interface.service';

@Component({
  selector: 'app-error-show',
  templateUrl: './error-show.component.html',
  styleUrls: ['./error-show.component.css']
})
export class ErrorShowComponent implements OnInit {
  @Input() Service: IMessengerConnector;
  @Input() error: any;
  @Input() reload = true;
  @Input() showReport = true;
  loadErrorText: string | void = '';
  @Output() onReload = new EventEmitter<any>();

  constructor(
    public interfaceService: InterfaceService,
    public senderService: SenderService,
    public wsService: WebsocketService
  ) {}
  ngOnInit(): void {
    this.loadErrorText = this.interfaceService.errorHandling(this.error, false);
  }
}
